import script from "./FileItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FileItem.vue?vue&type=script&setup=true&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=378b6af8&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378b6af8"]])

export default __exports__